import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidateChargeDetailResponse from "./customerRefundCandidateChargeDetailResponse";
import CustomerRefundCandidateFeeResponse from "./customerRefundCandidateFeeResponse";
import CustomerRefundCandidatePayGatePaymentResponse from "./customerRefundCandidatePayGatePaymentResponse";
import CustomerRefundCandidatePermittedActionsResponse from "./customerRefundCandidatePermittedActionsResponse";
import CustomerRefundCandidateTransferPaymentResponse from "./customerRefundCandidateTransferPaymentResponse";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";
import CustomerRefundCandidateRefundPaymentResponse from "./customerRefundCandidateRefundPaymentResponse";
import CustomerRefundType from "./customerRefundType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidateDetailResponse {
  /**
   * Customer refund candidate ID.
   */
  id!: string;

  /**
   * Official record ID.
   */
  @observable
  officialRecordId!: string;

  /**
   * If true - candidate is without refund fee.
   */
  @observable
  isWithoutRefundFee!: boolean;

  /**
   * Refund amount.
   */
  @observable
  refundAmount!: number;

  /**
   * Requested price list item ID - only specified when refund type is CUSTOMER_PARTIAL.
   */
  @observable
  requestedPriceListItemId?: string;

  @observable
  refundType!: CustomerRefundType;

  /**
   * Variable symbol.
   */
  @observable
  variableSymbol!: number;

  @observable
  @Type(() => CustomerRefundCandidateChargeDetailResponse)
  charge!: CustomerRefundCandidateChargeDetailResponse;

  @observable
  @Type(() => CustomerRefundCandidatePayGatePaymentResponse)
  originalPayGatePayment?: CustomerRefundCandidatePayGatePaymentResponse;

  @observable
  @Type(() => CustomerRefundCandidateTransferPaymentResponse)
  originalTransferPayment?: CustomerRefundCandidateTransferPaymentResponse;

  @observable
  @Type(() => DomesticBankAccountResponse)
  refundSenderBankAccount!: DomesticBankAccountResponse;

  @observable
  @Type(() => CustomerRefundCandidateRefundPaymentResponse)
  refundPayment!: CustomerRefundCandidateRefundPaymentResponse;

  /**
   * Refund fees.
   */
  @observable
  @Type(() => CustomerRefundCandidateFeeResponse)
  fees!: CustomerRefundCandidateFeeResponse[];

  @observable
  @Type(() => CustomerRefundCandidatePermittedActionsResponse)
  permittedActions!: CustomerRefundCandidatePermittedActionsResponse;
}
